<template>
  <div>
    <!-- Desktop: calendar grid skeleton -->
    <div class="cal-skel max-md:hidden">
      <div v-for="day in 7" :key="'h-'+day" class="py-2.5 px-2 flex items-center justify-center border-b border-black/6 bg-[#f6f6fa]">
        <skeleton width="28px" height="10px" rounded="4px"></skeleton>
      </div>
      <div v-for="cell in 35" :key="'c-'+cell" class="min-h-[90px] p-1.5 border-b border-black/4 border-r border-r-black/4 flex flex-col">
        <skeleton width="20px" height="12px" rounded="4px" class-name="mb-2"></skeleton>
        <skeleton v-if="cell % 3 === 0" width="80%" height="18px" rounded="6px" class-name="mb-1"></skeleton>
        <skeleton v-if="cell % 5 === 0" width="65%" height="18px" rounded="6px"></skeleton>
      </div>
    </div>

    <!-- Mobile: list skeleton -->
    <div class="hidden max-md:block">
      <div v-for="w in 4" :key="w" class="mb-4">
        <skeleton width="120px" height="10px" rounded="4px" class-name="mb-2 ml-1"></skeleton>
        <div class="flex flex-col gap-1">
          <div v-for="i in (w === 1 ? 3 : 2)" :key="i" class="flex items-center gap-3 px-3.5 py-3 bg-white border border-black/6 rounded-[16px]">
            <skeleton width="8px" height="8px" rounded="50%"></skeleton>
            <div class="flex-1">
              <skeleton width="140px" height="13px" rounded="4px" class-name="mb-1"></skeleton>
              <skeleton width="80px" height="11px" rounded="4px"></skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Skeleton from './Skeleton'

export default {
  name: 'SkeletonDeadlines',
  components: { Skeleton }
}
</script>

<style scoped>
.cal-skel {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  border: 1px solid rgba(0, 0, 0, 0.06);
  border-radius: 20px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}
</style>
